module.exports = __webpack_public_path__ + "static/media/home4.dbef67d7.svg";